"use client";

export type MeetUserAvatarVariant = "default" | "host" | "local" | "guest";

const sizeClasses = {
  sm: "size-8 text-xs",
  md: "h-8 w-8 text-xs sm:h-9 sm:w-9 sm:text-sm",
  lg: "size-10 text-sm"
} as const;

const fallbackClasses: Record<MeetUserAvatarVariant, string> = {
  default: "bg-gray-400 text-white",
  host: "bg-primary text-white",
  local: "bg-primary/20 text-primary",
  guest: "bg-amber-100 text-amber-700"
};

export function MeetUserAvatar({
  name,
  avatarUrl,
  variant = "default",
  size = "md",
  className = ""
}: {
  name: string;
  avatarUrl?: string | null;
  variant?: MeetUserAvatarVariant;
  size?: keyof typeof sizeClasses;
  className?: string;
}) {
  const initial = name?.[0]?.toUpperCase() || "?";
  const base = `flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold ${sizeClasses[size]} ${className}`;

  if (avatarUrl) {
    return (
      // eslint-disable-next-line @next/next/no-img-element -- Odoo CDN avatar URLs are external and dynamic
      <img src={avatarUrl} alt="" className={`${base} object-cover`} referrerPolicy="no-referrer" />
    );
  }

  return (
    <div aria-hidden className={`${base} ${fallbackClasses[variant]}`}>
      {initial}
    </div>
  );
}
